var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quill-editor',{attrs:{"content":_vm.editorData,"options":_vm.editorOption,"editor-toolbar":_vm.customToolbar},on:{"change":function($event){return _vm.onEditorChange($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }